import { Box, Flex, Text, Button, VStack } from '@skin-seoul/design-system';
import { motion, AnimatePresence } from 'motion/react';
import { COLORS, FONT_SIZES, FONT_WEIGHTS, BORDER_RADIUS, SPACING } from './constants';
import { ConfirmationOverlay } from './SharedStyles';
interface ConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
}
const MotionModal = motion.create(Box);
export const ConfirmationDialog = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}: ConfirmationDialogProps) => {
  return <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-component="ConfirmationDialog" data-sentry-source-file="ConfirmationDialog.tsx">
      {isOpen && <ConfirmationOverlay initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onCancel}>
          <MotionModal bg={COLORS.background} borderRadius={BORDER_RADIUS.md} p={SPACING.xl} maxW="400px" w="90%" boxShadow={`0 8px 32px ${COLORS.shadow}`} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} onClick={e => e.stopPropagation()}>
            <VStack align="stretch" gap={SPACING.lg}>
              <Text as="h3" style={{
            fontSize: FONT_SIZES.lg
          }} fontWeight={FONT_WEIGHTS.semibold} color={COLORS.text} m={`0 0 ${SPACING.md} 0`} fontFamily="General Sans">
                {title}
              </Text>
              <Text as="p" style={{
            fontSize: FONT_SIZES.sm
          }} color={COLORS.textSecondary} m={`0 0 ${SPACING.xl} 0`} fontFamily="General Sans" css={{
            lineHeight: '1.4'
          }}>
                {message}
              </Text>
              <Flex gap={SPACING.md} justify="flex-end">
                <Button p={`${SPACING.sm} ${SPACING.lg}`} borderRadius={BORDER_RADIUS.sm} style={{
              fontSize: FONT_SIZES.sm
            }} fontWeight={FONT_WEIGHTS.medium} cursor="pointer" border="none" bg="#f5f5f5" color={COLORS.text} fontFamily="General Sans" _hover={{
              opacity: 0.9
            }} onClick={onCancel}>
                  {cancelText}
                </Button>
                <Button p={`${SPACING.sm} ${SPACING.lg}`} borderRadius={BORDER_RADIUS.sm} style={{
              fontSize: FONT_SIZES.sm
            }} fontWeight={FONT_WEIGHTS.medium} cursor="pointer" border="none" bg={COLORS.primary} color={COLORS.white} fontFamily="General Sans" _hover={{
              opacity: 0.9
            }} onClick={onConfirm}>
                  {confirmText}
                </Button>
              </Flex>
            </VStack>
          </MotionModal>
        </ConfirmationOverlay>}
    </AnimatePresence>;
};